import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterTabsComponent } from './router-tabs.component';
import { MatTabScrollToCenterDirective } from './mat-tab-scroll-to-center.directive';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, MatTabsModule, RouterModule],
  declarations: [RouterTabsComponent, MatTabScrollToCenterDirective],
  exports: [RouterTabsComponent, MatTabScrollToCenterDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedUiRouterTabsModule {}
